import React from "react";

const EstimatorModal = ({ isOpen, onClose, image1, image2 }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="space-y-0">
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
          {" "}
          {/* Modal Box */}
          <div className="bg-white rounded-2xl shadow-lg p-6 w-11/12 sm:w-4/5 md:w-2/3 lg:w-1/2 relative max-h-[90vh] overflow-y-auto">
            {/* Close Button */}
            <button
              className="absolute top-3 right-3 text-gray-600 hover:text-black text-xl font-bold"
              onClick={onClose}
            >
              ✕
            </button>

            {/* Title */}
            <h2 className="text-xl md:text-2xl font-bold mb-6 text-center">
              Fabric Estimator
            </h2>

            {/* Images */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="flex justify-center">
                <img
                  src={image1}
                  alt="Estimator 1"
                  className="rounded-md shadow-md w-full max-w-xs object-contain"
                />
              </div>
              <div className="flex justify-center">
                <img
                  src={image2}
                  alt="Estimator 2"
                  className="rounded-md shadow-md w-full max-w-xs object-contain"
                />
              </div>
            </div>
            <p className="mt-6 p-4 bg-yellow-50 border-l-4 border-yellow-400 text-gray-700 rounded-md text-sm leading-relaxed">
              <span className="font-semibold text-yellow-700">Note:</span>{" "}
              According to your measurement designs, then depends on the flare
              fabric estimation will vary. For further queries regarding
              customization, please feel free to call us at{" "}
              <span className="font-medium text-black">9944592904</span>. We are
              always ready to assist you. Thank you!
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default EstimatorModal;
